import "./uploader.scss";

import { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import UploadFailure from "common/templates/upload_failure";
import Loader from "common/core/loading_indicator/small";
import Uploader from "common/core/uploader";

export default class TemplateUploader extends Component {
  state = {
    isUploading: false,
    uploadError: false,
    uploadErrorText: "",
  };

  onUploadFailure = (errors) => {
    const message = errors[0]?.specifics;
    this.setState({
      uploadError: true,
      uploadErrorText: message
        ? message
        : "Something went wrong. Please try again or contact support.",
    });
  };

  closeModal = () => {
    this.setState({ uploadError: false });
  };

  createTemplate = ({ s3Key }, onSuccess, onFailure) => {
    const { createTemplate, defaultDocumentSetings = {}, isPreset, organizationId } = this.props;
    this.setState({ isUploading: true });
    createTemplate({
      variables: {
        input: {
          organizationId,
          fileHandle: s3Key,
          preset: isPreset,
          ...defaultDocumentSetings,
        },
      },
    })
      .then((response) => {
        const { organizationDocumentTemplate, errors } =
          response.data.createOrganizationDocumentTemplate;
        if (errors) {
          onFailure(errors);
        } else {
          onSuccess(organizationDocumentTemplate);
        }
      })
      .finally(() => {
        this.setState({ isUploading: false });
      });
  };

  render() {
    const { uploaderClassName, title, buttonClassName, onUploadSuccess, buttonStyleProps } =
      this.props;
    const uploaderClasses = classnames("OrganizationTemplates--UploaderV2", uploaderClassName);

    return (
      <div className={uploaderClasses}>
        <Uploader
          className="uploader"
          createFile={this.createTemplate}
          onUploadSuccess={onUploadSuccess}
          onUploadFailure={this.onUploadFailure}
          buttonClassName={buttonClassName}
          title={title}
        >
          {!buttonStyleProps && (
            <div className="OrganizationTemplates--Uploader--CustomButton">
              {title}
              {this.state.isUploading && <Loader />}
            </div>
          )}
        </Uploader>
        <UploadFailure
          isOpen={this.state.uploadError}
          redirect={this.closeModal}
          errorText={this.state.uploadErrorText}
        />
      </div>
    );
  }
}

TemplateUploader.propTypes = {
  title: PropTypes.node.isRequired,
  buttonClassName: PropTypes.string,
  uploaderClassName: PropTypes.string,
  onUploadSuccess: PropTypes.func,
  createTemplate: PropTypes.func.isRequired,
  buttonStyleProps: PropTypes.object,
  defaultDocumentSetings: PropTypes.object,
  isPreset: PropTypes.bool,
  organizationId: PropTypes.string.isRequired,
};

TemplateUploader.defaultProps = {
  onUploadSuccess: () => {},
  isPreset: false,
};
